import { useCallback } from 'react';
import {
  AuditCheckboxComponent,
  AuditTagComponent,
  AuditTextComponent,
  FileUpload,
} from '@shared/components/blocks/types';
import { API } from '@shared/types/api';
import { Trigger } from '@shared/util/hooks';
import { isAuditCheckboxComponent, isAuditTagComponent, isAuditTextComponent } from '../../utils';
import { WorkflowAuditCheckbox } from './WorkflowAuditCheckbox';
import { WorkflowAuditTag } from './WorkflowAuditTag';
import { WorkflowAuditTextarea } from './WorkflowAuditTextarea';

interface Props {
  component: API.AnyComponent;
  currentValue: any;
  setValue: (value: any) => void;
  onDataChanged: (
    componentId: string,
    data: AuditTagComponent | AuditCheckboxComponent | AuditTextComponent,
  ) => void;
  filesRef: FileUpload[];
  notesRef: string;
  answerTrigger?: Trigger;
  anchorName?: string;
  isReadOnly?: boolean;
}

/** @deprecated Use AuditCheckboxEditField, AuditTagEditField, or AuditTextEditField instead. */
export function PrimaryAuditComponent(props: Props) {
  const onChangeHandler = getOnChange(
    props.component,
    props.setValue,
    props.onDataChanged,
    props.filesRef,
    props.notesRef,
  );
  const onChange = useCallback(onChangeHandler, [onChangeHandler]);

  if (isAuditTagComponent(props.component)) {
    return (
      <WorkflowAuditTag
        component={props.component}
        tags={props.currentValue}
        // @ts-expect-error -- strict migration
        trigger={props.answerTrigger}
        onChange={onChange}
        // @ts-expect-error -- strict migration
        anchorName={props.anchorName}
        isReadOnly={props.isReadOnly}
      />
    );
  }
  if (isAuditTextComponent(props.component)) {
    return (
      <WorkflowAuditTextarea
        // @ts-expect-error -- strict migration
        answerTrigger={props.answerTrigger}
        // @ts-expect-error -- strict migration
        label={props.component.label}
        value={props.currentValue}
        onChange={onChange}
        // @ts-expect-error -- strict migration
        anchorName={props.anchorName}
        isReadOnly={props.isReadOnly}
      />
    );
  }
  if (isAuditCheckboxComponent(props.component)) {
    return (
      <WorkflowAuditCheckbox
        component={props.component}
        checked={props.currentValue}
        onChange={onChange}
        isReadOnly={props.isReadOnly}
      />
    );
  }
  return <></>;
}

function getOnChange(
  component: API.AnyComponent,
  setValue: (value: any) => void,
  onDataChanged: (
    componentId: string,
    data: AuditTagComponent | AuditCheckboxComponent | AuditTextComponent,
  ) => void,
  filesRef: FileUpload[],
  notesRef: string,
  // @ts-expect-error -- strict migration
): (value: any) => void {
  if (isAuditTagComponent(component)) {
    return (selectedTags: string[]) => {
      setValue(selectedTags);
      onDataChanged(component.id, {
        tags: selectedTags,
        files: filesRef,
        notes: notesRef,
      });
    };
  }
  if (isAuditTextComponent(component)) {
    return (text: string) => {
      setValue(text);
      onDataChanged(component.id, { text, files: filesRef, notes: notesRef });
    };
  }
  if (isAuditCheckboxComponent(component)) {
    return (checked: boolean) => {
      setValue(checked);
      onDataChanged(component.id, { checked, files: filesRef, notes: notesRef });
    };
  }
}
